import React from 'react';

export default () => (
  <>
    <h6>Please drink responsibly</h6>
    <div className="bop-drinkResponsibly">
      <table className="bop-drinkResponsibly__table">
        <tr>
          <td colSpan="2">
            <span className="bop-drinkResponsibly__text bop-drinkResponsibly__text--warning">
              Know your limits
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan="2" className="bop-drinkResponsibly__info">
            <span className="bop-drinkResponsibly__text">
              The UK Chief Medical Officers recommend adults do not regularly drink more than
              <strong> 14 units per week</strong>
            </span>
          </td>
        </tr>
      </table>
    </div>
  </>
);
